import { ArrowUpRight } from 'lucide-react'
import React from 'react'
import Faqs1 from './Faqs1'
import { Link } from 'react-router-dom'

function PersonalTaxation() {
  return (
    <div>
           {/* Hero Section */}
      <section
        className="relative text-center w-full h-[600px]"
        style={{
          backgroundImage: "url('images/bg1.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white p-6">
          <h1 className="text-4xl font-bold mb-4 md:text-8xl">Personal Taxation </h1>
          <p className="text-lg max-w-3xl text-gray-400 md:text-3xl">
          Smart tax solutions for a stress-free financial future!.
          </p>
        </div>
      </section>


      <div className="flex flex-col items-center text-center gap-12 bg-slate-900 py-12 px-6 md:px-16">
  <h2 className="text-4xl md:text-6xl font-bold text-gray-100">
    Filing Personal Taxes
  </h2>

  <p className="text-2xl max-w-5xl text-justify text-gray-400  mx-auto">
    We provide comprehensive personal tax services to help you maximize refunds and minimize liabilities. 
    Our expert team ensures accurate tax preparation, compliance with the latest regulations, and strategic 
    tax planning tailored to your financial goals. Whether you need assistance with income tax filing, 
    deductions, credits, or complex tax situations, we simplify the process, so you can file with confidence 
    and peace of mind.
  </p>

  <div className="flex mt-3 justify-center">
               <Link to="/contactus">
    <button className="flex items-center gap-2 bg-amber-300 text-black p-3 px-6 text-lg font-semibold hover:bg-amber-600 transition">
      Schedule A Call
      <ArrowUpRight size={20} />
    </button></Link>
  </div>
</div>


<Faqs1/>

    </div>
  )
}

export default PersonalTaxation